<template>

  <v-card>
      <v-card-title primary-title>
        <div>
          <div class="message-data">
              <span class="message-data-name"><img :src="message.user.avatar"> {{ message.user.name }}</span>
              <span class="message-data-time">{{ message.timestamp | fromNow }}</span>
            </div>
            <div class="message my-message">
              <div v-if="!isFile(message)">{{ message.content }}</div>
              <div v-else @click.prevent="dialog = true">
                <img :src="message.image" alt="image" @click="copySrc">
              </div>
                <v-dialog v-model="dialog" persistent fullscreen transition="dialog-bottom-transition" :overlay=false>
                  <v-toolbar dark>
                    <v-btn icon @click.native="dialog = false" dark>
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Image View</v-toolbar-title>
                  </v-toolbar>
                  <v-card light>
                      <img class="full__sized" :src="src" alt="image">
                  </v-card>
                </v-dialog>
            </div>
        </div>
      </v-card-title>
    </v-card>

</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'single-message',
  props: ['message'],
  computed: {
    ...mapGetters(['currentUser'])
  },
  data () {
    return {
      src: '',
      dialog: false
    }
  },
  methods: {
    selfMessage (user) {
      return user.id === this.currentUser.uid
    },
    isFile (message) {
      return message.content == null && message.image != null
    },
    copySrc: function (img) {
      this.src = img.srcElement.src
    }
  },
  filters: {
    fromNow (value) {
      return moment(value).fromNow()
    }
  }
}

</script>

<style lang="stylus">
.message-data
  margin-bottom: 15px
  img
    width: 100%
    max-width: 20px
    border-radius: 100%
.message-data-time
  color: #a8aab1
  padding-left: 6px
.message
  color: white
  padding: 18px 20px
  line-height: 26px
  font-size: 16px
  border-radius: 7px
  margin-bottom: 30px
  position: relative
  background: #212121
  &:after
    bottom: 100%
    left: 9%
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
    border-bottom-color: #212121
    border-width: 10px
    margin-left: -10px
.blockout
  display: block !important
  clear: both
.input-group--text-field.input-group--textarea:not(.input-group--full-width) textarea
  padding: 10px 13px 0
.card
  img.full__sized
    max-width: 100%
    max-height: 100%
    margin: 0 auto
</style>



// WEBPACK FOOTER //
// SingleMessage.vue?1ffcdced